import { useState } from "react";
import { toast } from "sonner";
import { postForm } from "@/lib/api";
import { SITE } from "@/content/site";

export function useSubmission(path, messages) {
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (payload) => {
    setStatus("submitting");
    setError("");
    try {
      await postForm(path, payload);
      setStatus("success");
      toast.success(messages.success, { description: messages.successDescription });
      return true;
    } catch (err) {
      const detail = err?.response?.status < 500 ? err?.response?.data?.detail : null;
      const message =
        typeof detail === "string"
          ? detail
          : `We couldn't send that just now. Please try again, or email us at ${SITE.email}.`;
      setError(message);
      setStatus("error");
      toast.error("Something went wrong", { description: message });
      return false;
    }
  };

  const reset = () => {
    setStatus("idle");
    setError("");
  };

  return { status, error, submit, reset };
}
